import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { uerWorkOrderChangeAllowedSeasonsGql } from '../WorkOrderChangeQueries';

const requestId = 'uerWorkOrderChangeAllowedSeasons';

export const useUerWorkOrderChangeAllowedSeasons = (workOrderChangeId: number) => {
    const variables = useMemo(() => ({ workOrderChangeId }), [workOrderChangeId]);

    const [uerWorkOrderChangeAllowedSeasonsReset] = useResetStoreData({ requestId });

    const [uerWorkOrderChangeAllowedSeasonsData, uerWorkOrderChangeAllowedSeasonsStatus] = useRequest({
        requestId,
        query: uerWorkOrderChangeAllowedSeasonsGql,
        variables,
        withEffect: !!workOrderChangeId,
    });

    useEffect(() => {
        uerWorkOrderChangeAllowedSeasonsReset(undefined);
    }, [uerWorkOrderChangeAllowedSeasonsReset]);

    return {
        uerWorkOrderChangeAllowedSeasonsData,
        uerWorkOrderChangeAllowedSeasonsStatus,
    };
};
